import React from 'react';
import { NavigationCountBadge } from 'shared/components/ui/navigation-count-badge';
import { useTaskCounts } from 'shared/contexts/task-counts';

export const InboxCount: React.FC = () => {
  const counts = useTaskCounts();

  return <NavigationCountBadge count={counts?.inbox} />;
};
